'use client';

import { useState } from 'react';
import { Building2, MapPin, Users, Phone, Mail, TrendingUp, CheckCircle, AlertCircle, Clock, Search, FileText, Wifi, WifiOff,  } from 'lucide-react';

interface CountyOffice {
  id: string;
  county: string;
  region: string;
  director: string;
  phone: string;
  email: string;
  address: string;
  status: 'operational' | 'limited' | 'offline';
  staff: number;
  activeFiles: number;
  collectionMTD: number;
  collectionTarget: number;
  lastSync: string;
  established: number;
}

const countyOffices: CountyOffice[] = [
  {
    id: 'CO-001',
    county: 'Montserrado',
    region: 'Greater Monrovia',
    director: 'James K. Freeman',
    phone: '+231 770 123 456',
    email: 'montserrado@lra.gov.lr',
    address: 'Broad Street, Monrovia',
    status: 'operational',
    staff: 42,
    activeFiles: 1284,
    collectionMTD: 4820000,
    collectionTarget: 5000000,
    lastSync: '2 min ago',
    established: 2003,
  },
  {
    id: 'CO-002',
    county: 'Margibi',
    region: 'Central Region',
    director: 'Patricia A. Kollie',
    phone: '+231 770 234 567',
    email: 'margibi@lra.gov.lr',
    address: 'Kakata City Center',
    status: 'operational',
    staff: 18,
    activeFiles: 432,
    collectionMTD: 1240000,
    collectionTarget: 1500000,
    lastSync: '15 min ago',
    established: 2005,
  },
  {
    id: 'CO-003',
    county: 'Grand Bassa',
    region: 'South-Central Region',
    director: 'Emmanuel T. Sumo',
    phone: '+231 770 345 678',
    email: 'grandbassa@lra.gov.lr',
    address: 'Buchanan Commercial District',
    status: 'operational',
    staff: 14,
    activeFiles: 318,
    collectionMTD: 890000,
    collectionTarget: 1000000,
    lastSync: '1 hr ago',
    established: 2005,
  },
  {
    id: 'CO-004',
    county: 'Bong',
    region: 'North-Central Region',
    director: 'Cecelia M. Flomo',
    phone: '+231 770 456 789',
    email: 'bong@lra.gov.lr',
    address: 'Gbarnga Administrative Quarter',
    status: 'limited',
    staff: 11,
    activeFiles: 267,
    collectionMTD: 620000,
    collectionTarget: 900000,
    lastSync: '3 hrs ago',
    established: 2006,
  },
  {
    id: 'CO-005',
    county: 'Nimba',
    region: 'North-Eastern Region',
    director: 'Robert D. Pewee',
    phone: '+231 770 567 890',
    email: 'nimba@lra.gov.lr',
    address: 'Sanniquellie Town Square',
    status: 'operational',
    staff: 16,
    activeFiles: 389,
    collectionMTD: 1050000,
    collectionTarget: 1200000,
    lastSync: '30 min ago',
    established: 2005,
  },
  {
    id: 'CO-006',
    county: 'Lofa',
    region: 'North-Western Region',
    director: 'Agnes B. Kamara',
    phone: '+231 770 678 901',
    email: 'lofa@lra.gov.lr',
    address: 'Voinjama Central Office',
    status: 'limited',
    staff: 9,
    activeFiles: 198,
    collectionMTD: 410000,
    collectionTarget: 700000,
    lastSync: '6 hrs ago',
    established: 2007,
  },
  {
    id: 'CO-007',
    county: 'Grand Cape Mount',
    region: 'Western Region',
    director: 'Thomas J. Massaquoi',
    phone: '+231 770 789 012',
    email: 'grandcapemount@lra.gov.lr',
    address: 'Robertsport Civic Center',
    status: 'operational',
    staff: 8,
    activeFiles: 154,
    collectionMTD: 320000,
    collectionTarget: 400000,
    lastSync: '45 min ago',
    established: 2008,
  },
  {
    id: 'CO-008',
    county: 'Sinoe',
    region: 'South-Eastern Region',
    director: 'Mary E. Wreh',
    phone: '+231 770 890 123',
    email: 'sinoe@lra.gov.lr',
    address: 'Greenville District Office',
    status: 'offline',
    staff: 7,
    activeFiles: 112,
    collectionMTD: 0,
    collectionTarget: 350000,
    lastSync: '2 days ago',
    established: 2009,
  },
  {
    id: 'CO-009',
    county: 'Maryland',
    region: 'South-Eastern Region',
    director: 'David O. Nyahn',
    phone: '+231 770 901 234',
    email: 'maryland@lra.gov.lr',
    address: 'Harper City Hall Annex',
    status: 'operational',
    staff: 10,
    activeFiles: 221,
    collectionMTD: 540000,
    collectionTarget: 600000,
    lastSync: '20 min ago',
    established: 2007,
  },
  {
    id: 'CO-010',
    county: 'River Cess',
    region: 'South-Central Region',
    director: 'Hannah F. Toe',
    phone: '+231 770 012 345',
    email: 'rivercess@lra.gov.lr',
    address: 'Cestos City Field Office',
    status: 'limited',
    staff: 6,
    activeFiles: 89,
    collectionMTD: 180000,
    collectionTarget: 300000,
    lastSync: '4 hrs ago',
    established: 2010,
  },
  {
    id: 'CO-011',
    county: 'Gbarpolu',
    region: 'North-Western Region',
    director: 'Isaac N. Kpoto',
    phone: '+231 770 111 222',
    email: 'gbarpolu@lra.gov.lr',
    address: 'Bopolu Administrative Center',
    status: 'operational',
    staff: 7,
    activeFiles: 134,
    collectionMTD: 290000,
    collectionTarget: 320000,
    lastSync: '1 hr ago',
    established: 2011,
  },
  {
    id: 'CO-012',
    county: 'Grand Gedeh',
    region: 'South-Eastern Region',
    director: 'Victoria S. Gaye',
    phone: '+231 770 333 444',
    email: 'grandgedeh@lra.gov.lr',
    address: 'Zwedru Revenue Office',
    status: 'operational',
    staff: 9,
    activeFiles: 176,
    collectionMTD: 430000,
    collectionTarget: 480000,
    lastSync: '50 min ago',
    established: 2008,
  },
  {
    id: 'CO-013',
    county: 'Grand Kru',
    region: 'South-Eastern Region',
    director: 'Samuel A. Blamo',
    phone: '+231 770 555 666',
    email: 'grandkru@lra.gov.lr',
    address: 'Barclayville District HQ',
    status: 'limited',
    staff: 5,
    activeFiles: 67,
    collectionMTD: 120000,
    collectionTarget: 250000,
    lastSync: '8 hrs ago',
    established: 2012,
  },
  {
    id: 'CO-014',
    county: 'Rivercess',
    region: 'South-Central Region',
    director: 'Comfort B. Mulbah',
    phone: '+231 770 777 888',
    email: 'rivercess2@lra.gov.lr',
    address: 'Cestos Sub-Office',
    status: 'offline',
    staff: 4,
    activeFiles: 43,
    collectionMTD: 0,
    collectionTarget: 150000,
    lastSync: '3 days ago',
    established: 2014,
  },
  {
    id: 'CO-015',
    county: 'Bomi',
    region: 'Western Region',
    director: 'Francis K. Dolo',
    phone: '+231 770 999 000',
    email: 'bomi@lra.gov.lr',
    address: 'Tubmanburg Revenue Center',
    status: 'operational',
    staff: 8,
    activeFiles: 148,
    collectionMTD: 310000,
    collectionTarget: 360000,
    lastSync: '25 min ago',
    established: 2009,
  },
];

const statusConfig = {
  operational: {
    label: 'Operational',
    color: 'text-emerald-400',
    bg: 'bg-emerald-400/10 border-emerald-400/20',
    icon: CheckCircle,
    dot: 'bg-emerald-400',
  },
  limited: {
    label: 'Limited',
    color: 'text-amber-400',
    bg: 'bg-amber-400/10 border-amber-400/20',
    icon: AlertCircle,
    dot: 'bg-amber-400',
  },
  offline: {
    label: 'Offline',
    color: 'text-red-400',
    bg: 'bg-red-400/10 border-red-400/20',
    icon: WifiOff,
    dot: 'bg-red-400',
  },
};

function formatCurrency(val: number) {
  if (val >= 1000000) return `$${(val / 1000000).toFixed(2)}M`;
  if (val >= 1000) return `$${(val / 1000).toFixed(0)}K`;
  return `$${val}`;
}

export default function CountyOfficesClient() {
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState<'all' | 'operational' | 'limited' | 'offline'>('all');
  const [selectedOffice, setSelectedOffice] = useState<CountyOffice | null>(null);

  const filtered = countyOffices.filter((o) => {
    const matchSearch =
      o.county.toLowerCase().includes(search.toLowerCase()) ||
      o.director.toLowerCase().includes(search.toLowerCase()) ||
      o.region.toLowerCase().includes(search.toLowerCase());
    const matchStatus = statusFilter === 'all' || o.status === statusFilter;
    return matchSearch && matchStatus;
  });

  const totalStaff = countyOffices.reduce((s, o) => s + o.staff, 0);
  const totalFiles = countyOffices.reduce((s, o) => s + o.activeFiles, 0);
  const totalMTD = countyOffices.reduce((s, o) => s + o.collectionMTD, 0);
  const totalTarget = countyOffices.reduce((s, o) => s + o.collectionTarget, 0);
  const operationalCount = countyOffices.filter((o) => o.status === 'operational').length;

  return (
    <div className="flex flex-col h-full bg-[#0f1117] text-white overflow-hidden">
      {/* Header */}
      <div className="flex-shrink-0 px-6 py-5 border-b border-white/8">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-lg">
              <Building2 className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-white">County Offices</h1>
              <p className="text-xs text-gray-400 mt-0.5">Field Office Management · {countyOffices.length} Offices Nationwide</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs text-gray-500 bg-white/5 border border-white/10 rounded-lg px-3 py-1.5">
              Last updated: just now
            </span>
          </div>
        </div>

        {/* KPI Row */}
        <div className="grid grid-cols-4 gap-3 mt-5">
          {[
            { label: 'Total Offices', value: countyOffices.length, sub: `${operationalCount} operational`, icon: Building2, color: 'from-blue-500 to-indigo-600' },
            { label: 'Total Staff', value: totalStaff, sub: 'Field officers', icon: Users, color: 'from-violet-500 to-purple-600' },
            { label: 'Active Files', value: totalFiles.toLocaleString(), sub: 'Open cases', icon: FileText, color: 'from-amber-500 to-orange-600' },
            { label: 'MTD Collections', value: formatCurrency(totalMTD), sub: `${Math.round((totalMTD / totalTarget) * 100)}% of target`, icon: TrendingUp, color: 'from-emerald-500 to-teal-600' },
          ].map((kpi) => (
            <div key={kpi.label} className="bg-white/4 border border-white/8 rounded-xl p-4 flex items-center gap-3">
              <div className={`w-9 h-9 rounded-lg bg-gradient-to-br ${kpi.color} flex items-center justify-center flex-shrink-0`}>
                <kpi.icon className="w-4 h-4 text-white" />
              </div>
              <div>
                <div className="text-lg font-bold text-white leading-none">{kpi.value}</div>
                <div className="text-xs text-gray-400 mt-1">{kpi.label}</div>
                <div className="text-xs text-gray-500">{kpi.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Filters */}
      <div className="flex-shrink-0 px-6 py-3 border-b border-white/8 flex items-center gap-3">
        <div className="relative flex-1 max-w-xs">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
          <input
            type="text"
            placeholder="Search county, director, region..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full bg-white/5 border border-white/10 rounded-lg pl-9 pr-3 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-blue-500/50"
          />
        </div>
        <div className="flex items-center gap-2">
          {(['all', 'operational', 'limited', 'offline'] as const).map((s) => (
            <button
              key={s}
              onClick={() => setStatusFilter(s)}
              className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${
                statusFilter === s
                  ? 'bg-blue-600 text-white' :'bg-white/5 text-gray-400 hover:bg-white/10 border border-white/10'
              }`}
            >
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>
        <div className="ml-auto text-xs text-gray-500">{filtered.length} offices</div>
      </div>

      {/* Content */}
      <div className="flex flex-1 overflow-hidden">
        {/* Office Grid */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
            {filtered.map((office) => {
              const sc = statusConfig[office.status];
              const pct = office.collectionTarget > 0 ? Math.round((office.collectionMTD / office.collectionTarget) * 100) : 0;
              const isSelected = selectedOffice?.id === office.id;
              return (
                <div
                  key={office.id}
                  onClick={() => setSelectedOffice(isSelected ? null : office)}
                  className={`bg-white/4 border rounded-xl p-4 cursor-pointer transition-all hover:bg-white/6 ${
                    isSelected ? 'border-blue-500/50 ring-1 ring-blue-500/20' : 'border-white/8'
                  }`}
                >
                  {/* Card Header */}
                  <div className="flex items-start justify-between mb-3">
                    <div>
                      <div className="flex items-center gap-2">
                        <h3 className="font-semibold text-white text-sm">{office.county} County</h3>
                        <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs border ${sc.bg} ${sc.color}`}>
                          <span className={`w-1.5 h-1.5 rounded-full ${sc.dot}`} />
                          {sc.label}
                        </span>
                      </div>
                      <p className="text-xs text-gray-500 mt-0.5">{office.region}</p>
                    </div>
                    <span className="text-xs text-gray-600 font-mono">{office.id}</span>
                  </div>

                  {/* Director */}
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-7 h-7 rounded-full bg-gradient-to-br from-blue-500/30 to-indigo-600/30 border border-blue-500/20 flex items-center justify-center text-xs font-bold text-blue-300">
                      {office.director.split(' ').map((n) => n[0]).slice(0, 2).join('')}
                    </div>
                    <div>
                      <div className="text-xs font-medium text-gray-200">{office.director}</div>
                      <div className="text-xs text-gray-500">County Director</div>
                    </div>
                  </div>

                  {/* Stats Row */}
                  <div className="grid grid-cols-3 gap-2 mb-3">
                    <div className="bg-white/4 rounded-lg p-2 text-center">
                      <div className="text-sm font-bold text-white">{office.staff}</div>
                      <div className="text-xs text-gray-500">Staff</div>
                    </div>
                    <div className="bg-white/4 rounded-lg p-2 text-center">
                      <div className="text-sm font-bold text-white">{office.activeFiles}</div>
                      <div className="text-xs text-gray-500">Files</div>
                    </div>
                    <div className="bg-white/4 rounded-lg p-2 text-center">
                      <div className="text-sm font-bold text-white">{pct}%</div>
                      <div className="text-xs text-gray-500">Target</div>
                    </div>
                  </div>

                  {/* Collection Progress */}
                  <div className="mb-3">
                    <div className="flex justify-between text-xs text-gray-500 mb-1">
                      <span>MTD Collections</span>
                      <span className="text-gray-300">{formatCurrency(office.collectionMTD)} / {formatCurrency(office.collectionTarget)}</span>
                    </div>
                    <div className="h-1.5 bg-white/8 rounded-full overflow-hidden">
                      <div
                        className={`h-full rounded-full transition-all ${
                          pct >= 80 ? 'bg-emerald-500' : pct >= 50 ? 'bg-amber-500' : 'bg-red-500'
                        }`}
                        style={{ width: `${Math.min(pct, 100)}%` }}
                      />
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="flex items-center justify-between text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                      <MapPin className="w-3 h-3" />
                      <span className="truncate max-w-[120px]">{office.address}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Clock className="w-3 h-3" />
                      <span>{office.lastSync}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Detail Panel */}
        {selectedOffice && (
          <div className="w-80 flex-shrink-0 border-l border-white/8 overflow-y-auto p-5 bg-white/2">
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-bold text-white">{selectedOffice.county} County Office</h2>
              <button onClick={() => setSelectedOffice(null)} className="text-gray-500 hover:text-white text-lg leading-none">×</button>
            </div>

            <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs border mb-4 ${statusConfig[selectedOffice.status].bg} ${statusConfig[selectedOffice.status].color}`}>
              <span className={`w-2 h-2 rounded-full ${statusConfig[selectedOffice.status].dot}`} />
              {statusConfig[selectedOffice.status].label}
            </div>

            <div className="space-y-3 text-sm">
              <div className="bg-white/4 border border-white/8 rounded-lg p-3">
                <div className="text-xs text-gray-500 mb-2 font-medium uppercase tracking-wide">Contact</div>
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-gray-300">
                    <Phone className="w-3.5 h-3.5 text-gray-500 flex-shrink-0" />
                    <span className="text-xs">{selectedOffice.phone}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-300">
                    <Mail className="w-3.5 h-3.5 text-gray-500 flex-shrink-0" />
                    <span className="text-xs">{selectedOffice.email}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-300">
                    <MapPin className="w-3.5 h-3.5 text-gray-500 flex-shrink-0" />
                    <span className="text-xs">{selectedOffice.address}</span>
                  </div>
                </div>
              </div>

              <div className="bg-white/4 border border-white/8 rounded-lg p-3">
                <div className="text-xs text-gray-500 mb-2 font-medium uppercase tracking-wide">Performance</div>
                <div className="space-y-2">
                  {[
                    { label: 'MTD Collections', value: formatCurrency(selectedOffice.collectionMTD) },
                    { label: 'Monthly Target', value: formatCurrency(selectedOffice.collectionTarget) },
                    { label: 'Achievement', value: `${selectedOffice.collectionTarget > 0 ? Math.round((selectedOffice.collectionMTD / selectedOffice.collectionTarget) * 100) : 0}%` },
                    { label: 'Active Files', value: selectedOffice.activeFiles },
                    { label: 'Staff Count', value: selectedOffice.staff },
                    { label: 'Established', value: selectedOffice.established },
                  ].map((row) => (
                    <div key={row.label} className="flex justify-between">
                      <span className="text-xs text-gray-500">{row.label}</span>
                      <span className="text-xs text-gray-200 font-medium">{row.value}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-white/4 border border-white/8 rounded-lg p-3">
                <div className="text-xs text-gray-500 mb-2 font-medium uppercase tracking-wide">Sync Status</div>
                <div className="flex items-center gap-2">
                  {selectedOffice.status === 'offline' ? (
                    <WifiOff className="w-4 h-4 text-red-400" />
                  ) : (
                    <Wifi className="w-4 h-4 text-emerald-400" />
                  )}
                  <span className="text-xs text-gray-300">Last sync: {selectedOffice.lastSync}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
